/**
 * Absolutize an asset URL against `REACT_APP_BACKEND_URL`.
 *
 *   - Empty / falsy → "" (caller decides fallback)
 *   - Already absolute (starts with `http`) → returned unchanged
 *   - Root-relative (starts with `/`) → prefixed with backend base
 *   - Anything else (bare filename) → returned unchanged
 *
 * Shared by the storyboard detail view + the new gallery grid so
 * both render exactly the same URL for a given scene.
 */
const API_BASE = process.env.REACT_APP_BACKEND_URL;

export function imgUrl(raw) {
  if (!raw) return "";
  if (raw.startsWith("http")) return raw;
  if (raw.startsWith("/")) return `${API_BASE}${raw}`;
  return raw;
}
